import { type FC, useEffect } from 'react'
import { getIncodeClient } from '@egw/risk-service'
import { Logger } from '@egw/logger'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

const log = new Logger('DocV')

interface ProcessIdProps {
  session: { token: string }
  onSuccess: (result: unknown) => void
}

export const ProcessId: FC<ProcessIdProps> = ({ session, onSuccess }) => {
  log.info('ProcessId: Starting process with session:', session)

  useEffect(() => {
    getIncodeClient()
      .processId({ token: session.token })
      .then((result) => {
        onSuccess(result)
      })
      .catch((error) => {
        log.error('ProcessId: Error processing ID', error)
      })
  }, [onSuccess, session])

  return (
    <SkeletonTheme baseColor="#eeefee" highlightColor="rgba(255, 255, 255, 0.5)">
      <Skeleton count={1} height="100px" className="mb-10" />
      <Skeleton count={5} height="50px" />
    </SkeletonTheme>
  )
}
